import React, { useCallback } from 'react';
import {
   Input,
} from 'reactstrap';
import PropTypes from 'prop-types';
import withInputErrorMessage from '../withInputErrorMessage';
import withNumberInput from './withNumberInput';

const NumberInput = (props) => {
   // Stops 'e' from breaking the input by ignoring the e input
   const handleKeyDown = useCallback((event) => {
      if (event?.key === 'e') {
         event.preventDefault();
      }
   }, []);

   return (
      <Input
         onKeyDown={handleKeyDown}
         type='number'
         name={props.name}
         onChange={props.onChange}
         onBlur={props.onBlur}
         value={props.isDisabled && props.isValueHiddenWhenDisabled ? '' : props.value}
         disabled={props.isDisabled}
         className={props.className}
      />
   );
};

NumberInput.propTypes = {
   name: PropTypes.string.isRequired,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   isValueHiddenWhenDisabled: PropTypes.bool,
   className: PropTypes.string,
};

NumberInput.defaultProps = {
   value: '',
   isDisabled: false,
   isValueHiddenWhenDisabled: false,
   className: '',
};

export default withNumberInput(withInputErrorMessage(NumberInput));
